
app.controller(
    'CreationController', ['$scope', '$rootScope', '$timeout', 'toastr', '$document','$sce', '$translate', CreationController]
);



function CreationController($scope, $rootScope, $timeout, toastr, $document, $sce, $translate) {
    $scope.moduleState = 'list';
    $scope.first = false;
    $scope.second = false;
    $scope.show = true;
    $scope.free = false;
    $translate.use($rootScope.LangForInterface);
    $scope.guest = {
        name: 'Amanda Lear, invitée',
        vernaculaire: 'Douze expériences choisies, subjectives et assumées',
        clients: [{
            'titre': 'Institution, Beaux-Arts',
            'sousTitre': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' + ' nulli velariis',
            'description': 'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.'
        }]
    };

    $scope.ckOptions = {
        forcePasteAsPlainText: true,
        language: 'fr',
        allowedContent: true,
        entities: false,
        disableNativeSpellChecker: false,
        toolbar: [
            {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', 'Format', 'RemoveFormat', 'Paste', 'PasteText', '-', 'Undo', 'Redo', 'Subscript', 'Superscript']
            },
            {
                name: 'editing',
                items: ['Scayt']
            },
            {
                name: 'link',
                items: ['Link', 'UnLink', 'Anchor']
            },
            {
                name: 'insert',
                items: ['Image']
            },
            {
                name: 'list',
                items: ['NumberedList', 'BulletedList']
            },
            {
                name: 'source',
                items: ['Styles', 'Source']
            },
            {
                name: 'preview',
                items: ['Preview']
            }
        ],
        removeButtons: 'Table',
        extraPlugins: 'preview',
        scayt_autoStartup: true
    };

    $scope.previsual = false;


    $scope.ckOptionsEditClient = {
        forcePasteAsPlainText: true,
        language: 'fr',
        allowedContent: true,
        entities: false,
        toolbar: [
            {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', 'Format', 'RemoveFormat', 'Paste', 'PasteText', '-', 'Undo', 'Redo']
            },
            {
                name: 'editing',
                items: ['Scayt']
            },
            {
                name: 'link',
                items: ['Link', 'UnLink', 'Anchor']
            },
            {
                name: 'insert',
                items: ['Image']
            },
            {
                name: 'list',
                items: ['NumberedList', 'BulletedList']
            },
            {
                name: 'source',
                items: ['Styles', 'Source']
            },
            {
                name: 'preview',
                items: ['Preview']
            }
        ],
        removeButtons: '',
        extraPlugins: 'preview',
        scayt_autoStartup: true
    };




    $scope.details = [
        {
            name: 'LV print',
            checked: false
        },
        {
            name: 'LV app',
            checked: false
        }, {
            name: 'LV print',
            checked: false
        }, {
            name: 'LV app',
            checked: false
        }, {
            name: 'LV print',
            checked: false
        }, {
            name: 'LV app',
            checked: false
        }, {
            name: 'LV app',
            checked: false
        }, {
            name: 'LV app',
            checked: false
        }, {
            name: 'LV app',
            checked: false
        }, {
            name: 'LV app',
            checked: false

        }
    ];
    $scope.detailsSelection = [];
    $scope.devises = [
        {
            name: 'Euro',
            checked: false
        },
        {
            name: 'Dollar',
            checked: false
        }, {
            name: 'Yen',
            checked: false
        }, {
            name: 'Livre',
            checked: false
        }, {
            name: 'Dollar canadien',
            checked: false
        }, {
            name: 'Dollar australien',
            checked: false
        }
    ];
    $scope.classification = {};
    $scope.associations = {};
    $scope.lieu = {};
    $scope.contact = {};
    $scope.media = {};
    $scope.evenement = {};
    $scope.informations = {};
    $scope.etablissements = [
        {
            name: 'Grand Hôtel du Palais Royal',
            type: 'Hôtels',
            style: 'Chic parisien',
            checked: false
        },
        {
            name: 'Hôtel Regina',
            type: 'Hôtels',
            style: 'Classique classé',
            checked: false
        }, {
            name: 'Frenchie',
            type: 'Restaurants',
            style: 'Paradis pour les foodies',
            checked: false
        }, {
            name: 'Le Procope',
            type: 'Restaurants',
            style: 'Classique classé',
            checked: false
        }
    ];

    $scope.classification.priorities = [
        {
            name: 'High',
            checked: false
        },
        {
            name: 'Average',
            checked: false
        },
        {
            name: 'Low',
            checked: false
        },
        {
            name: 'High',
            checked: false
        },
        {
            name: 'Average',
            checked: false
        },
        {
            name: 'Low',
            checked: false
        },
    ];
    $scope.classification.editorials = [
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },

    ];
    $scope.classification.rubriques = [
        {
            name: 'LV app',
            checked: false
        },
        {
            name: 'LV print',
            checked: false
        },
        {
            name: 'LV app',
            checked: false
        },
        {
            name: 'LV print',
            checked: false
        }
    ];
    $scope.classification.sousRubriques = [
        {
            name: 'Sous-rubrique 1',
            checked: false
        },
        {
            name: 'Sous-rubrique 2',
            checked: false
        },
        {
            name: 'Sous-rubrique 3',
            checked: false
        },
        {
            name: 'Sous-rubrique 4',
            checked: false
        },
        {
            name: 'Sous-rubrique 5',
            checked: false
        }, {
            name: 'Sous-rubrique 6',
            checked: false
        }, {
            name: 'Sous-rubrique 7',
            checked: false
        }, {
            name: 'Sous-rubrique 8',
            checked: false
        }, {
            name: 'Sous-rubrique 9',
            checked: false
        }
    ];
    $scope.classification.typologies = [
        {
            name: 'Typologie 1',
            checked: false
        },
        {
            name: 'Typologie 2',
            checked: false
        },
        {
            name: 'Typologie 3',
            checked: false
        },
        {
            name: 'Typologie 4',
            checked: false
        },
        {
            name: 'Typologie 5',
            checked: false
        },
        {
            name: 'Typologie 6',
            checked: false
        },
        {
            name: 'Typologie 7',
            checked: false
        },
        {
            name: 'Typologie 8',
            checked: false
        },
        {
            name: 'Typologie 9',
            checked: false
        },
    ];
    $scope.classification.services = [
        {
            name: 'Service 1',
            checked: false
        },
        {
            name: 'Service 2',
            checked: false
        },
        {
            name: 'Service 3',
            checked: false
        },
        {
            name: 'Service 4',
            checked: false
        },
        {
            name: 'Service 5',
            checked: false
        },
        {
            name: 'Equipement 1',
            checked: false
        },
        {
            name: 'Equipement 2',
            checked: false
        },
        {
            name: 'Equipement 3',
            checked: false
        },
        {
            name: 'Equipement 4',
            checked: false
        },
        {
            name: 'Equipement 5',
            checked: false
        }
    ];
    $scope.classification.periodicites = [
        {
            name: 'Périodicité 1',
            checked: false
        },
        {
            name: 'Périodicité 2',
            checked: false
        },
        {
            name: 'Périodicité 3',
            checked: false
        },
        {
            name: 'Périodicité 4',
            checked: false
        },
        {
            name: 'Périodicité 5',
            checked: false
        },
        {
            name: 'Périodicité 6',
            checked: false
        },
        {
            name: 'Périodicité 7',
            checked: false
        },
        {
            name: 'Périodicité 8',
            checked: false
        },
        {
            name: 'Périodicité 9',
            checked: false
        }
    ];

    $scope.associations.associationsEditoriales = [
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        }
    ];
    $scope.associations.invites = [
        {
            name: 'Amanda Lear',
            checked: false
        },
        {
            name: 'Omar Sy',
            checked: false
        },
        {
            name: 'Jean Reno',
            checked: false
        },
        {
            name: 'Florence Foresti',
            checked: false
        },
        {
            name: 'Teddy Riner',
            checked: false
        },
        {
            name: 'Jean Dujardin',
            checked: false
        },
        {
            name: 'Fabrice Luchini',
            checked: false
        },

    ];

    $scope.lieu.quartiers = [
        {
            name: 'Quartier 1',
            checked: false
        },
        {
            name: 'Quartier 2',
            checked: false
        },
        {
            name: 'Quartier 3',
            checked: false
        },
        {
            name: 'Quartier 4',
            checked: false
        },
        {
            name: 'Quartier 5',
            checked: false
        },
        {
            name: 'Quartier 6',
            checked: false
        },
        {
            name: 'Quartier 7',
            checked: false
        },
        {
            name: 'Quartier 8',
            checked: false
        },
        {
            name: 'Quartier 9',
            checked: false
        },
    ];
    $scope.lieu.zones = [
        {
            name: 'Zone 1',
            checked: false
        },
        {
            name: 'Zone 2',
            checked: false
        },
        {
            name: 'Zone 3',
            checked: false
        },
        {
            name: 'Zone 4',
            checked: false
        },
        {
            name: 'Zone 5',
            checked: false
        },
        {
            name: 'Zone 6',
            checked: false
        },
        {
            name: 'Zone 7',
            checked: false
        },
        {
            name: 'Zone 8',
            checked: false
        },
        {
            name: 'Zone 9',
            checked: false
        },
    ];

    $scope.contact.urlTypes = [
        {
            name: 'Relative',
            checked: false
        },
        {
            name: 'Absolue',
            checked: false
        },
        {
            name: 'HTTP',
            checked: false
        },
        {
            name: 'HTTPS',
            checked: false
        }
    ];

    $scope.media.priorities = [
        {
            name: 'High',
            checked: false
        },
        {
            name: 'Average',
            checked: false
        },
        {
            name: 'Low',
            checked: false
        },
        {
            name: 'High',
            checked: false
        },
        {
            name: 'Average',
            checked: false
        },
        {
            name: 'Low',
            checked: false
        },
    ];
    $scope.media.editorials = [
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },

    ];
    $scope.media.rubriques = [
        {
            name: 'LV app',
            checked: false
        },
        {
            name: 'LV print',
            checked: false
        },
        {
            name: 'LV app',
            checked: false
        },
        {
            name: 'LV print',
            checked: false
        }
    ];
    $scope.media.sousRubriques = [
        {
            name: 'Sous-rubrique 1',
            checked: false
        },
        {
            name: 'Sous-rubrique 2',
            checked: false
        },
        {
            name: 'Sous-rubrique 3',
            checked: false
        },
        {
            name: 'Sous-rubrique 4',
            checked: false
        },
        {
            name: 'Sous-rubrique 5',
            checked: false
        }, {
            name: 'Sous-rubrique 6',
            checked: false
        }, {
            name: 'Sous-rubrique 7',
            checked: false
        }, {
            name: 'Sous-rubrique 8',
            checked: false
        }, {
            name: 'Sous-rubrique 9',
            checked: false
        }
    ];
    $scope.media.typologies = [
        {
            name: 'Typologie 1',
            checked: false
        },
        {
            name: 'Typologie 2',
            checked: false
        },
        {
            name: 'Typologie 3',
            checked: false
        },
        {
            name: 'Typologie 4',
            checked: false
        },
        {
            name: 'Typologie 5',
            checked: false
        },
        {
            name: 'Typologie 6',
            checked: false
        },
        {
            name: 'Typologie 7',
            checked: false
        },
        {
            name: 'Typologie 8',
            checked: false
        },
        {
            name: 'Typologie 9',
            checked: false
        },
    ];
    $scope.media.services = [
        {
            name: 'Service 1',
            checked: false
        },
        {
            name: 'Service 2',
            checked: false
        },
        {
            name: 'Service 3',
            checked: false
        },
        {
            name: 'Service 4',
            checked: false
        },
        {
            name: 'Service 5',
            checked: false
        },
        {
            name: 'Equipement 1',
            checked: false
        },
        {
            name: 'Equipement 2',
            checked: false
        },
        {
            name: 'Equipement 3',
            checked: false
        },
        {
            name: 'Equipement 4',
            checked: false
        },
        {
            name: 'Equipement 5',
            checked: false
        }
    ];
    $scope.media.periodicites = [
        {
            name: 'Périodicité 1',
            checked: false
        },
        {
            name: 'Périodicité 2',
            checked: false
        },
        {
            name: 'Périodicité 3',
            checked: false
        },
        {
            name: 'Périodicité 4',
            checked: false
        },
        {
            name: 'Périodicité 5',
            checked: false
        },
        {
            name: 'Périodicité 6',
            checked: false
        },
        {
            name: 'Périodicité 7',
            checked: false
        },
        {
            name: 'Périodicité 8',
            checked: false
        },
        {
            name: 'Périodicité 9',
            checked: false
        }
    ];

    $scope.evenement.priorities = [
        {
            name: 'High',
            checked: false
        },
        {
            name: 'Average',
            checked: false
        },
        {
            name: 'Low',
            checked: false
        },
        {
            name: 'High',
            checked: false
        },
        {
            name: 'Average',
            checked: false
        },
        {
            name: 'Low',
            checked: false
        },
    ];
    $scope.evenement.editorials = [
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },
        {
            name: 'LV Print',
            checked: false
        },
        {
            name: 'LV App',
            checked: false
        },

    ];
    $scope.evenement.rubriques = [
        {
            name: 'LV app',
            checked: false
        },
        {
            name: 'LV print',
            checked: false
        },
        {
            name: 'LV app',
            checked: false
        },
        {
            name: 'LV print',
            checked: false
        }
    ];
    $scope.evenement.sousRubriques = [
        {
            name: 'Sous-rubrique 1',
            checked: false
        },
        {
            name: 'Sous-rubrique 2',
            checked: false
        },
        {
            name: 'Sous-rubrique 3',
            checked: false
        },
        {
            name: 'Sous-rubrique 4',
            checked: false
        },
        {
            name: 'Sous-rubrique 5',
            checked: false
        }, {
            name: 'Sous-rubrique 6',
            checked: false
        }, {
            name: 'Sous-rubrique 7',
            checked: false
        }, {
            name: 'Sous-rubrique 8',
            checked: false
        }, {
            name: 'Sous-rubrique 9',
            checked: false
        }
    ];
    $scope.evenement.typologies = [
        {
            name: 'Typologie 1',
            checked: false
        },
        {
            name: 'Typologie 2',
            checked: false
        },
        {
            name: 'Typologie 3',
            checked: false
        },
        {
            name: 'Typologie 4',
            checked: false
        },
        {
            name: 'Typologie 5',
            checked: false
        },
        {
            name: 'Typologie 6',
            checked: false
        },
        {
            name: 'Typologie 7',
            checked: false
        },
        {
            name: 'Typologie 8',
            checked: false
        },
        {
            name: 'Typologie 9',
            checked: false
        },
    ];
    $scope.evenement.services = [
        {
            name: 'Service 1',
            checked: false
        },
        {
            name: 'Service 2',
            checked: false
        },
        {
            name: 'Service 3',
            checked: false
        },
        {
            name: 'Service 4',
            checked: false
        },
        {
            name: 'Service 5',
            checked: false
        },
        {
            name: 'Equipement 1',
            checked: false
        },
        {
            name: 'Equipement 2',
            checked: false
        },
        {
            name: 'Equipement 3',
            checked: false
        },
        {
            name: 'Equipement 4',
            checked: false
        },
        {
            name: 'Equipement 5',
            checked: false
        }
    ];
    $scope.evenement.periodicites = [
        {
            name: 'Périodicité 1',
            checked: false
        },
        {
            name: 'Périodicité 2',
            checked: false
        },
        {
            name: 'Périodicité 3',
            checked: false
        },
        {
            name: 'Périodicité 4',
            checked: false
        },
        {
            name: 'Périodicité 5',
            checked: false
        },
        {
            name: 'Périodicité 6',
            checked: false
        },
        {
            name: 'Périodicité 7',
            checked: false
        },
        {
            name: 'Périodicité 8',
            checked: false
        },
        {
            name: 'Périodicité 9',
            checked: false
        }
    ];

    $scope.informations.agrements = [
        {
            name: 'Agrément 1',
            checked: false
        },
        {
            name: 'Agrément 2',
            checked: false
        },
        {
            name: 'Agrément 3',
            checked: false
        },
        {
            name: 'Agrément 4',
            checked: false
        },
        {
            name: 'Agrément 5',
            checked: false
        },
        {
            name: 'Agrément 6',
            checked: false
        },
        {
            name: 'Agrément 7',
            checked: false
        },
        {
            name: 'Agrément 8',
            checked: false
        },
        {
            name: 'Agrément 9',
            checked: false
        }
    ];

    $scope.informations.files = [
        {
            name: 'CityGuide_18_CAPETOWN_A_BAT_18_CAPETOWN_A_BAT_'
        }
    ];


    /**Swipe edit sidepanel**/
    $scope.showDetail = function (page) {
        angular.element(document.getElementById('container-body')).addClass('sidenav__edit--is-open');
        $timeout(
            function (event) {
                $scope.show = true;
            }
        );
        $scope.moduleState = page;
    };

    $scope.config = {
        // autoHideScrollbar: false,
        setHeight : 500,
    };


    /** Show previsual **/
    $scope.showPrevisual = function () {
        $scope.previsual = !$scope.previsual;
    };

    /**
     * List of events
     * [Events]
     * @type {Array}
     */
    $scope.events = [
        {
            image: '/event-image-1.png',
            title: 'Event 1',
            category: 'Categorie 1',
            date: '17/05/2017 au 25/05/2017'
        },
        {
            image: '/event-image-2.png',
            title: 'Event 2',
            category: 'Categorie 2',
            date: '25/12/2017 au 25/01/2018'
        },
        {
            image: '/event-image-3.png',
            title: 'Event 3',
            category: 'Categorie 3',
            date: '01/01/2017 au 02/02/2017'
        },
        {
            image: '/event-image-1.png',
            title: 'Event 4',
            category: 'Categorie 4',
            date: '02/02/2017 au 03/03/2017'
        },
        {
            image: '/event-image-2.png',
            title: 'Event 5',
            category: 'Categorie 5',
            date: '03/03/2017 au 04/04/2017'
        },
        {
            image: '/event-image-3.png',
            title: 'Event 6',
            category: 'Categorie 6',
            date: '04/04/2017 au 05/05/2017'
        }
    ];

    $scope.currentEvent = $scope.events[0];

    /**
     * Simulation succes form
     * @method
     * @return {[type]} [description]
     */
    $scope.save = function () {
        toastr.success('L\'enregistrement a été effectué avec succès.');
    };

    /**
     * Close sidebar menu
     * @method
     * @return {[type]} [description]
     */
    $scope.close = function () {
        angular.element(document.getElementById('container-body')).removeClass('sidenav__edit--is-open');
    };

    /**
     * Initialized Jquery
     * @type {Boolean}
     */
    $scope.$on(
        '$viewContentLoaded',
        function () {
            menu();
            tabs();
            $timeout(
                function () {
                    $scope.first = true;
                    $scope.show = false;
                }, 100
            );

        }
    );

    /**
     * Show tabs visible
     * @method
     * @param  {[type]} tabs [description]
     * @return {[type]}      [description]
     */
    $scope.showTabs = function (tabs) {
        if (tabs === 'first') {
            $scope.first = true;
            $scope.second = false;
        } else if (tabs === 'second') {
            $scope.first = false;
            $scope.second = true;
        }
    };

    /**
     * Select prev scrollbars
     * @method
     * @param  {[type]} container       [description]
     * @param  {[type]} containerActive [description]
     * @return {[type]}                 [description]
     */
    $scope.prev = function (container, containerActive) {
        var container = angular.element(document.getElementById(container));
        var containerActive = angular.element(document.getElementById(containerActive));
        var scrollspy = containerActive.find('.active').prev().attr('du-scrollspy');
        if (scrollspy != undefined) {
            var someElement = angular.element(document.getElementById(scrollspy));
            container.scrollTo(someElement, 0, 200);
        }
    };

    /**
     * Select next scrollbars
     * @method
     * @param  {[type]} container       [description]
     * @param  {[type]} containerActive [description]
     * @return {[type]}                 [description]
     */
    $scope.next = function (container, containerActive) {
        var container = angular.element(document.getElementById(container));
        var containerActive = angular.element(document.getElementById(containerActive));
        var scrollspy = containerActive.find('.active').next().attr('du-scrollspy');
        if (scrollspy != undefined) {
            var someElement = angular.element(document.getElementById(scrollspy));
            container.scrollTo(someElement, 0, 200);
        }
    };

    $scope.tarifGens = [
        'Tarif 3'
    ];

    $scope.addGenTarif = function () {
        $scope.tarifGens.push('tarif')
    };

    $scope.removeGenTarif = function (tarif) {
        $scope.tarifGens.splice(tarif, 1);
    };

    $scope.periodes = [
        {

        }
    ];

    $scope.addPeriode = function () {
        var index = $scope.periodes.push({});
    };

    $scope.removePeriode = function (periode) {
        $scope.periodes.splice(periode, 1);
    };

    /**
     * Add a new "horaire" in "periode"
     * @param periode
     */
    $scope.addHoraireIn = function (periode) {
        if(!$scope.periodes[periode].horaires)
            $scope.periodes[periode].horaires = [];
        $scope.periodes[periode].horaires.push({});
    };


    $scope.removeHoraire = function (periode, horaire) {
        $scope.periodes[periode].horaires.splice(horaire, 1);
    };

    /**
     * Add a new "tarif" in "horaire"
     * @param periode
     * @param horaire
     */
    $scope.addTarifIn = function (periode, horaire) {
        if(!$scope.periodes[periode].horaires[horaire].tarifs)
            $scope.periodes[periode].horaires[horaire].tarifs = [];
        $scope.periodes[periode].horaires[horaire].tarifs.push({});
    };



    $scope.removeTarif = function (periode, horaire, tarif) {
        $scope.periodes[periode].horaires[horaire].tarifs.splice(tarif, 1);
    };





    /**
     * add details for select for side
     * @method
     * @return {[type]} [description]
     */
    $scope.addDetails = function () {
        if ($scope.detailsInput != "") {

            $scope.details.push(
                {
                    name : $scope.detailsInput,
                    checked : $scope.checked
                }
            )

            $scope.detailsInput = "";
        }
    };

    $scope.addClassificationPriority = function () {
        if ($scope.classification.priorityInput != "") {

            $scope.classification.priorities.push(
                {
                    name : $scope.classification.priorityInput,
                    checked : $scope.classification.checked
                }
            );

            $scope.classification.priorityInput = "";
        }
    };

    $scope.updateClassificationPriorityChecked = function (key) {
        $scope.classification.countPriority = 0;
        $scope.classification.priorities[key].checked = $scope.classification.priorities[key] == false ? true : false;
        $scope.classification.priorities.forEach(
            function (value) {
                if (value.checked) {
                    $scope.classification.countPriority++;
                }
            }
        );
    };

    /**
     * Update the current event
     * @method
     * @return {[type]} [description]
     */
    $scope.showEvent = function (event) {
        $scope.currentEvent = event;
    };

    $scope.UpdateCheckboxChecked = function (key) {


        $scope.count = 0;
        $scope.details[key].checked = $scope.details[key].checked == false ? true : false;
        $scope.details.forEach(
            function (value) {
                if (value.checked) {
                    $scope.count++;
                }
            }
        );
    };

    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#fileInfoSource').trigger('click');
            }, 0, false
        );
    };

    $scope.addFile = function () {
        var files = angular.element("#fileInfoSource").get(0).files;
        $scope.uploadDragNDrop(files);
    };

    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(
                {
                    name : name
                }
            );
        }
        $scope.$apply();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };
    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function(htmlContent){
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function(){
        $scope.$emit('updateFieldTags');
    };

}
